import ReactGA from "react-ga4";

const TRACKING_IDS = {
  "localhost": "G-XXXXXXX", // Optional: Local testing ID
  "sportinghip.com": "G-8SGD5P2TJD", // ✅ New SportingHip GA ID
  "www.sportinghip.com": "G-8SGD5P2TJD",
  "fastactionbasketball.com": "G-YBGNMN2G7G", // ✅ FastAction GA ID
  "www.fastactionbasketball.com": "G-YBGNMN2G7G",
};

// export const initGA = () => {
//   const hostname = window.location.hostname.replace(/^www\./, "");
//   const pathname = window.location.pathname;

//   // ✅ Skip FastAction's GA if it's running as a slug under SportingHip
//   if (
//     hostname === "sportinghip.com" &&
//     pathname.includes("/fastactionbasketball")
//   ) {
//     console.warn("Skipping GA for slug-based FastAction on sportinghip.com");
//     return;
//   }

//   const trackingId = TRACKING_IDS[hostname];

//   if (trackingId) {
//     ReactGA.initialize(trackingId);
//     ReactGA.set({
//       page_title:
//         hostname === "fastactionbasketball.com"
//           ? "FastAction Basketball"
//           : "SportingHip",
//       page_location: window.location.href,
//     });
//   } else {
//     console.warn("🚫 No GA Tracking ID for this domain:", window.location.hostname);
//   }
// };
export const initGA = () => {
  const hostname = window.location.hostname.replace(/^www\./, "");
  const trackingId = TRACKING_IDS[hostname];


  if (!trackingId) {
    console.warn("No GA Tracking ID for:", hostname);
    return;
  }

  ReactGA.initialize(trackingId);

};